module.exports = __webpack_public_path__ + "img/service-bg.509687e7.png";